import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doPostDownload } from './utils'

const API_ROOT2 = 'http://localhost/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`
const API_ROOT_VERs = `${API_ROOT}/files`

export const getAssetMigration = (projectCode) => {
  const url = `${API_ROOT_VER}/asset-migration?projectCode=${projectCode || ''}`
  return doGet(url)
}

export const saveAssetMigrationRequest = (request) => {
  const url = `${API_ROOT_VER}/asset-migration/save`
  return doPost(url, request)
}